var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code-wrapper"},[_c('img',{attrs:{"src":require("../../assets/img/ceshi/code.png"),"alt":""}}),_c('span',{staticClass:"download-tip"},[_vm._v("右键点击二维码，选择“图片另存为”，保存到本地。")])])
}]

export { render, staticRenderFns }